import React from "react";
import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <Container style={{ maxWidth: "800px", marginTop: "50px" }}>
      <h1>Политика обработки данных</h1>
      <p>
        Мы уважаем вашу конфиденциальность и обязуемся защищать ваши личные данные. Эта политика обработки данных
        описывает, как мы собираем, используем, сохраняем и защищаем ваши персональные данные, а также ваши права в
        отношении данных, которые мы обрабатываем.
      </p>

      <h3>1. Сбор данных</h3>
      <p>
        Мы собираем информацию, которую вы предоставляете при использовании наших сервисов, включая имя, адрес электронной
        почты, номер телефона, дату рождения и другую информацию, необходимую для предоставления наших услуг. Мы также можем
        собирать информацию о вашем устройстве и браузере, включая IP-адрес, тип устройства, версию операционной системы и
        другую техническую информацию, которая помогает нам улучшать качество обслуживания.
      </p>

      <h3>2. Использование данных</h3>
      <p>
        Собранные данные могут быть использованы для различных целей, таких как:
      </p>
      <ul>
        <li>Предоставление и улучшение наших услуг;</li>
        <li>Обработка ваших запросов, обращений и заказов;</li>
        <li>Обеспечение безопасности наших сервисов;</li>
        <li>Связь с вами для отправки уведомлений и обновлений;</li>
        <li>Анализ данных для улучшения пользовательского опыта и качества услуг;</li>
        <li>Рекламные и маркетинговые цели (при условии вашего согласия).</li>
      </ul>

      <h3>3. Защита данных</h3>
      <p>
        Мы принимаем все необходимые меры для защиты ваших данных от несанкционированного доступа, потери или изменения. Все
        персональные данные, которые мы собираем, хранятся в безопасной среде с использованием современных технологий шифрования
        и методов защиты. Мы ограничиваем доступ к вашим данным только тем сотрудникам, которым необходимо их использовать в рамках
        выполнения своих обязанностей.
      </p>
      <p>
        Несмотря на то, что мы принимаем все возможные меры для защиты ваших данных, следует помнить, что передача данных через
        интернет не может быть абсолютно безопасной, и мы не можем гарантировать полную безопасность данных на всех этапах
        их передачи.
      </p>

      <h3>4. Хранение данных</h3>
      <p>
        Мы храним ваши персональные данные только в течение необходимого времени для выполнения целей, указанных в этой политике.
        После завершения обработки ваших данных или по вашему запросу они будут удалены или анонимизированы, если это не противоречит
        нашим обязательствам по сохранению данных, предусмотренным законом.
      </p>

      <h3>5. Передача данных третьим лицам</h3>
      <p>
        Мы не передаем ваши персональные данные третьим лицам без вашего согласия, за исключением случаев, когда это требуется
        законодательством, для выполнения обязательств перед вами, или для защиты наших законных интересов. Например, мы можем
        передавать данные поставщикам услуг, которые помогают нам в осуществлении нашей деятельности, таким как хостинг,
        аналитика и маркетинг.
      </p>
      <p>
        Мы обязуемся обеспечить, чтобы все третьи лица, с которыми мы работаем, соблюдали соответствующие стандарты безопасности
        данных и использовали ваши данные только в соответствии с нашей политикой.
      </p>

      <h3>6. Ваши права</h3>
      <p>
        Вы имеете право на доступ, исправление, удаление, ограничение обработки и переносимость ваших персональных данных. Вы
        также имеете право отказаться от обработки ваших данных для маркетинговых целей. Чтобы воспользоваться этими правами,
        пожалуйста, свяжитесь с нами по контактным данным, указанным в разделе ниже.
      </p>
      <p>
        В случае, если вы считаете, что мы нарушили ваши права в отношении данных, вы имеете право подать жалобу в орган, ответственный
        за защиту данных в вашей юрисдикции.
      </p>

      <h3>7. Использование cookie</h3>
      <p>
        Мы используем cookie для улучшения качества наших услуг и пользовательского опыта. Cookies помогают нам запомнить ваши
        предпочтения и предоставлять вам более персонализированный контент. Вы можете настроить свой браузер так, чтобы он блокировал
        или удалял cookie, но в этом случае некоторые функции нашего сайта могут работать не корректно.
      </p>

      <h3>8. Изменения в политике обработки данных</h3>
      <p>
        Мы оставляем за собой право обновлять или изменять эту политику в любое время. Все изменения будут опубликованы на этой
        странице с указанием даты последнего обновления. Пожалуйста, периодически проверяйте эту страницу, чтобы быть в курсе
        актуальных изменений.
      </p>

      <h3>9. Контакты</h3>
      <p>
        Если у вас есть вопросы или запросы относительно нашей политики обработки данных, пожалуйста, свяжитесь с нами по адресу:
      </p>
      <address>
        Email: info@losjurados.com <br />
      </address>
    </Container>
  );
};

export default PrivacyPolicy;
